function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4824 2.84944L12.61 2.84944C12.8221 2.86244 13.0325 2.938 13.2104 3.07612L13.312 3.16631L19.8989 9.75325C20.3214 10.1757 20.3214 10.8623 19.8989 11.2848C19.5089 11.6748 18.8939 11.7049 18.4689 11.375L18.3674 11.2848L12.5466 5.46488L6.72587 11.2848C6.33587 11.6748 5.72081 11.7049 5.29587 11.375L5.19431 11.2848C4.80431 10.8948 4.77425 10.2806 5.10412 9.85481L5.19431 9.75325L11.7812 3.16631C11.9762 2.97131 12.2273 2.8665 12.4832 2.85106L12.4824 2.84944ZM11.4619 9.64194L11.4619 21.1575C11.4619 21.7547 11.9486 22.2406 12.545 22.2406C13.1438 22.2406 13.6281 21.7539 13.6281 21.1575L13.6281 9.64194C13.6281 9.04313 13.1438 8.55888 12.545 8.55888C11.9478 8.55888 11.4619 9.04313 11.4619 9.64194Z",
  fill: "currentColor"
});

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.03583bae.svg";
export { ForwardRef as ReactComponent };